import { createFileRoute, notFound } from '@tanstack/react-router';
import Organizations from '../../../pages/organizations/Organizations';
import { VIEW_ORGANIZATIONS_PAGE } from '../../../utils/permissions';

export const Route = createFileRoute('/_authenticated/_navbar/organizations')({
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_ORGANIZATIONS_PAGE)) {
      throw notFound();
    }
  },
  component: Organizations,
});
